export const Types = {
  GET_APPLICATION_BIOGAS_LIST_REQUEST: 'GET_APPLICATION_BIOGAS_LIST_REQUEST',
  GET_APPLICATION_BIOGAS_LIST_SUCCESS: 'GET_APPLICATION_BIOGAS_LIST_SUCCESS',
  GET_APPLICATION_BIOGAS_LIST_FAIL: 'GET_APPLICATION_BIOGAS_LIST_FAIL',

  DELETE_APPLICATION_BIOGAS_REQUEST: 'DELETE_APPLICATION_BIOGAS_REQUEST',
  DELETE_APPLICATION_BIOGAS_SUCCESS: 'DELETE_APPLICATION_BIOGAS_SUCCESS',
  DELETE_APPLICATION_BIOGAS_FAIL: 'DELETE_APPLICATION_BIOGAS_FAIL',
  DELETE_APPLICATION_BIOGAS_CLEAN: 'DELETE_APPLICATION_BIOGAS_CLEAN',

  CREATE_APPLICATION_BIOGAS_REQUEST: 'CREATE_APPLICATION_BIOGAS_REQUEST',
  CREATE_APPLICATION_BIOGAS_SUCCESS: 'CREATE_APPLICATION_BIOGAS_SUCCESS',
  CREATE_APPLICATION_BIOGAS_FAIL: 'CREATE_APPLICATION_BIOGAS_FAIL',
  CREATE_APPLICATION_BIOGAS_CLEAN: 'CREATE_APPLICATION_BIOGAS_CLEAN',

  GET_ID_APPLICATION_BIOGAS_REQUEST: 'GET_ID_APPLICATION_BIOGAS_REQUEST',
  GET_ID_APPLICATION_BIOGAS_SUCCESS: 'GET_ID_APPLICATION_BIOGAS_SUCCESS',
  GET_ID_APPLICATION_BIOGAS_FAIL: 'GET_ID_APPLICATION_BIOGAS_FAIL',
  GET_ID_APPLICATION_BIOGAS_CLEAN: 'GET_ID_APPLICATION_BIOGAS_CLEAN',

  UPDATE_APPLICATION_BIOGAS_REQUEST: 'UPDATE_APPLICATION_BIOGAS_REQUEST',
  UPDATE_APPLICATION_BIOGAS_SUCCESS: 'UPDATE_APPLICATION_BIOGAS_SUCCESS',
  UPDATE_APPLICATION_BIOGAS_FAIL: 'UPDATE_APPLICATION_BIOGAS_FAIL',
  UPDATE_APPLICATION_BIOGAS_CLEAN: 'UPDATE_APPLICATION_BIOGAS_CLEAN',
};

const INIT_STATE = {
  loading: false,
  error: false,
  data: [],
  amount: 10,

  deleteLoading: false,
  deleteError: false,
  deleteSuccess: false,

  createLoading: false,
  createError: false,
  createSuccess: false,

  idLoading: false,
  idError: false,
  idData: null,

  updateLoading: false,
  updateError: false,
  updateSuccess: false,
};

export default function ApplicationBiogas(state = INIT_STATE, action) {
  switch (action.type) {
    case Types.GET_APPLICATION_BIOGAS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case Types.GET_APPLICATION_BIOGAS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data || action.payload,
        amount: action.payload.total,
      };
    case Types.GET_APPLICATION_BIOGAS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case Types.DELETE_APPLICATION_BIOGAS_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        deleteError: false,
        deleteSuccess: false,
      };
    case Types.DELETE_APPLICATION_BIOGAS_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteError: false,
        deleteSuccess: true,
      };
    case Types.DELETE_APPLICATION_BIOGAS_FAIL:
      return {
        ...state,
        deleteLoading: false,
        deleteError: true,
        deleteSuccess: false,
      };
    case Types.DELETE_APPLICATION_BIOGAS_CLEAN:
      return {
        ...state,
        deleteLoading: false,
        deleteError: false,
        deleteSuccess: false,
      };

    case Types.CREATE_APPLICATION_BIOGAS_REQUEST:
      return {
        ...state,
        createLoading: true,
        createError: false,
        createSuccess: false,
      };
    case Types.CREATE_APPLICATION_BIOGAS_SUCCESS:
      return {
        ...state,
        createLoading: false,
        createError: false,
        createSuccess: true,
      };
    case Types.CREATE_APPLICATION_BIOGAS_FAIL:
      return {
        ...state,
        createLoading: false,
        createError: true,
        createSuccess: false,
      };
    case Types.CREATE_APPLICATION_BIOGAS_CLEAN:
      return {
        ...state,
        createLoading: false,
        createError: false,
        createSuccess: false,
      };

    case Types.GET_ID_APPLICATION_BIOGAS_REQUEST:
      return {
        ...state,
        idLoading: true,
        idError: false,
      };
    case Types.GET_ID_APPLICATION_BIOGAS_SUCCESS:
      return {
        ...state,
        idLoading: false,
        idError: false,
        idData: action.payload,
      };
    case Types.GET_ID_APPLICATION_BIOGAS_FAIL:
      return {
        ...state,
        idLoading: false,
        idError: true,
      };
    case Types.GET_ID_APPLICATION_BIOGAS_CLEAN:
      return {
        ...state,
        idLoading: false,
        idError: false,
        idData: null,
      };

    case Types.UPDATE_APPLICATION_BIOGAS_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: false,
        updateSuccess: false,
      };
    case Types.UPDATE_APPLICATION_BIOGAS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateError: false,
        updateSuccess: true,
      };
    case Types.UPDATE_APPLICATION_BIOGAS_FAIL:
      return {
        ...state,
        updateLoading: false,
        updateError: true,
        updateSuccess: false,
      };
    case Types.UPDATE_APPLICATION_BIOGAS_CLEAN:
      return {
        ...state,
        updateLoading: false,
        updateError: false,
        updateSuccess: false,
      };

    default:
      return state;
  }
}

export const Creators = {
  // GET
  getApplicationBiogasListRequest: payload => ({
    type: Types.GET_APPLICATION_BIOGAS_LIST_REQUEST,
    payload,
  }),
  getApplicationBiogasListSuccess: payload => ({
    type: Types.GET_APPLICATION_BIOGAS_LIST_SUCCESS,
    payload,
  }),
  getApplicationBiogasListFail: () => ({
    type: Types.GET_APPLICATION_BIOGAS_LIST_FAIL,
  }),

  // DELETE
  deleteApplicationBiogasRequest: payload => ({
    type: Types.DELETE_APPLICATION_BIOGAS_REQUEST,
    payload,
  }),
  deleteApplicationBiogasSuccess: () => ({
    type: Types.DELETE_APPLICATION_BIOGAS_SUCCESS,
  }),
  deleteApplicationBiogasFail: () => ({
    type: Types.DELETE_APPLICATION_BIOGAS_FAIL,
  }),
  deleteApplicationBiogasClean: () => ({
    type: Types.DELETE_APPLICATION_BIOGAS_CLEAN,
  }),

  // CREATE
  createApplicationBiogasRequest: payload => ({
    type: Types.CREATE_APPLICATION_BIOGAS_REQUEST,
    payload,
  }),
  createApplicationBiogasSuccess: payload => ({
    type: Types.CREATE_APPLICATION_BIOGAS_SUCCESS,
    payload,
  }),
  createApplicationBiogasFail: () => ({
    type: Types.CREATE_APPLICATION_BIOGAS_FAIL,
  }),
  createApplicationBiogasClean: () => ({
    type: Types.CREATE_APPLICATION_BIOGAS_CLEAN,
  }),

  // GET ID
  getIdApplicationBiogasRequest: payload => ({
    type: Types.GET_ID_APPLICATION_BIOGAS_REQUEST,
    payload,
  }),
  getIdApplicationBiogasSuccess: payload => ({
    type: Types.GET_ID_APPLICATION_BIOGAS_SUCCESS,
    payload,
  }),
  getIdApplicationBiogasFail: () => ({
    type: Types.GET_ID_APPLICATION_BIOGAS_FAIL,
  }),
  getIdApplicationBiogasClean: () => ({
    type: Types.GET_ID_APPLICATION_BIOGAS_CLEAN,
  }),

  // UPDATE
  updateApplicationBiogasRequest: payload => ({
    type: Types.UPDATE_APPLICATION_BIOGAS_REQUEST,
    payload,
  }),
  updateApplicationBiogasSuccess: payload => ({
    type: Types.UPDATE_APPLICATION_BIOGAS_SUCCESS,
    payload,
  }),
  updateApplicationBiogasFail: () => ({
    type: Types.UPDATE_APPLICATION_BIOGAS_FAIL,
  }),
  updateApplicationBiogasClean: () => ({
    type: Types.UPDATE_APPLICATION_BIOGAS_CLEAN,
  }),
};
